/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.circle-plus-filled\":\"Plus-merkki ympyrän sisällä\"}");